export default __webpack_public_path__ + "static/media/23.31535cb2.webp";